import {
  getActivimeterCalibrations,
  removeActivimeterCalibration,
  setActivimeterCalibrationFilters,
  updateActivimeterCalibration,
} from '@state/reducers/activimeterCalibrationReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { ActivimeterCalibrationDto } from '@services/dtos'
import { useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { AppDispatch } from '@state/store'
import ActivimeterCalibrationForm from '../forms/ActivimeterCalibrationForm'

export default function ActivimeterCalibrationsTable() {
  const columns: GridColumns<ActivimeterCalibrationDto> = useMemo(
    () => [
      {
        field: 'equipment',
        headerName: 'Equipement',
        minWidth: 150,
        valueGetter: (params) => params.row.equipment.name,
      },
      {
        field: 'isotope',
        headerName: 'Isotope',
        minWidth: 150,
        valueGetter: (params) => params.row.isotope.name,
      },
      { field: 'value', headerName: 'Calibre', minWidth: 150 },
      {
        field: 'forbidElutionCreation',
        headerName: 'Interdire Elution',
        minWidth: 130,
        type: 'boolean',
      },
      {
        field: 'forbidMrpCreation',
        headerName: 'Interdire MRP',
        minWidth: 120,
        type: 'boolean',
      },
      {
        field: 'forbidSyringeCreation',
        headerName: 'Interdire Seringue',
        minWidth: 150,
        type: 'boolean',
      },
      {
        field: 'forbidSingleDoseCreation',
        headerName: 'Interdire Dose unitaire',
        minWidth: 180,
        type: 'boolean',
      },
      {
        field: 'forbidInhalationCreation',
        headerName: 'Interdire Inhalation',
        minWidth: 160,
        type: 'boolean',
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<ActivimeterCalibrationDto>
      columns={columns}
      selectRows={(state) => state.activimeterCalibration.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setActivimeterCalibrationFilters({ includeInactive: true }))
        return dispatch(getActivimeterCalibrations())
      }}
      deleteThunk={removeActivimeterCalibration}
      toggleThunk={(id, isActive) =>
        updateActivimeterCalibration({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setActivimeterCalibrationFilters({ page }))
        dispatch(getActivimeterCalibrations())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <ActivimeterCalibrationForm
          editingActivimeterCalibration={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="calibrage activimètre"
      resourcePrefix="le "
    />
  )
}
